import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-outfit font-bold mb-8">About Pinaka Education</h1>

        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <p>
            <strong className="text-foreground">Pinaka Education</strong> is an online test preparation platform dedicated to helping Class 10, 11, 12, JEE, and NEET aspirants achieve their academic goals.
          </p>

          <h2 className="text-xl font-outfit font-semibold text-foreground mt-8">Our Mission</h2>
          <p>
            We believe every student deserves access to high-quality practice material. Our platform provides expertly crafted test series that mirror actual exam patterns, helping students build confidence and improve their performance.
          </p>

          <h2 className="text-xl font-outfit font-semibold text-foreground mt-8">What We Offer</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Curated test series for JEE Main, JEE Advanced, and NEET</li>
            <li>Subject-wise and full-length practice tests</li>
            <li>Detailed performance analytics and insights</li>
            <li>Instant results with question-by-question review</li>
            <li>Affordable pricing with free trial tests</li>
          </ul>

          <h2 className="text-xl font-outfit font-semibold text-foreground mt-8">Our Values</h2>
          <p>
            <strong className="text-foreground">Aim · Achieve · Succeed</strong> — We are committed to providing a focused, distraction-free environment where students can prepare effectively and track their progress over time.
          </p>

          <h2 className="text-xl font-outfit font-semibold text-foreground mt-8">Contact</h2>
          <p>
            Have questions or feedback? Reach us at{' '}
            <a href="mailto:support@pinakaclasses.com" className="text-primary hover:underline">
              support@pinakaclasses.com
            </a>{' '}
            or WhatsApp us at{' '}
            <a href="https://wa.me/918601375676" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
              +91 86013 75676
            </a>.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
